import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { CoreButtonComponent } from '../custom-components/core-button/core-button.component';

@Component({
  selector: 'app-error-dialog',
  imports: [MatDialogClose, CoreButtonComponent],
  templateUrl: './error-dialog.html',
  styleUrl: './error-dialog.scss',
})
export class ErrorDialog {
  readonly data = inject<string>(MAT_DIALOG_DATA);
  public dialogRef = inject(MatDialogRef<ErrorDialog>);

  closeAction() {
    this.dialogRef.close(true);
  }
}
